// Import your agriculture images
import farming1 from '../Images/romi2/romi (1).jpg';
import farming2 from '../Images/romi2/romi (2).jpg';
import farming3 from '../Images/romi2/romi (3).jpg';
import farming4 from '../Images/romi2/romi (4).jpg';
import farming5 from '../Images/romi2/romi (5).jpg';
import farming6 from '../Images/romi2/romi (6).jpg';
import farming7 from '../Images/romi2/romi (7).jpg';
import farming8 from '../Images/romi2/romi (8).jpg';
import farming9 from '../Images/romi2/romi (9).jpg';
import farming10 from '../Images/romi2/romi (10).jpg';
import farming11 from '../Images/romi2/romi (11).jpg';
import farming12 from '../Images/romi2/romi (12).jpg';
import farming13 from '../Images/romi2/romi (13).jpg';
import farming14 from '../Images/romi2/romi (14).jpg';
import farming15 from '../Images/romi2/romi (15).jpg';
import farming16 from '../Images/romi2/romi (16).jpg';
import farming17 from '../Images/romi2/romi (17).jpg';


export const agricultureImages = {
  farming: {
    title: 'Tomato Sauce Program',
    images: [
      { id: 1, src: farming1 },
      { id: 2, src: farming2 },
      { id: 3, src: farming3 },
      { id: 4, src: farming4 },
      { id: 5, src: farming5 },
      { id: 6, src: farming6 },
      { id: 7, src: farming7 },
      { id: 8, src: farming8 },
      { id: 9, src: farming9 },
      { id: 10, src: farming10 },
      { id: 11, src: farming11 },
      { id: 12, src: farming12 },
      { id: 13, src: farming13 },
      { id: 14, src: farming14 },
      { id: 15, src: farming15 },
      { id: 16, src: farming16 },
      { id: 17, src: farming17 },
    ]
  },
   videos: {
    title: 'Videos',
    videos: [
    
    ]
  },
 
  
  
};